/**
 * @file Testimonials.
 */

import KeenSlider from 'keen-slider';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Testimonials component.
 */
const vTestimonials = () => {
	const testimonials = document.querySelector('.v-testimonials');

	if (!testimonials) {
		return;
	}

	const slider = testimonials.querySelector('.v-testimonials__list');

	if (!slider.classList.contains('keen-slider')) {
		return;
	}

	gsap.registerPlugin(ScrollToPlugin);

	let isAnimating = false;
	const slides    = testimonials.querySelectorAll('.v-testimonials__item');
	const nextBtn   = testimonials.querySelector('.v-testimonials__btn--next');
	const prevBtn   = testimonials.querySelector('.v-testimonials__btn--prev');
	const dots      = testimonials.querySelectorAll('.v-testimonials__dot');
	const keen      = new KeenSlider(slider, {
		loop:             true,
		drag:             false,
		selector:         '.v-testimonials__item',
		renderMode:       'custom',
		defaultAnimation: {
			duration: 500,
		},
		detailsChanged: (instance) => {
			/* eslint-disable no-param-reassign */
			instance.slides.forEach((s, idx) => {
				s.style.opacity = instance.track.details.slides[idx].portion;
			});
			/* eslint-enable no-param-reassign */
		},
		animationStarted: ({ track }) => {
			isAnimating   = true;
			slides[track.details.rel].classList.remove('v-testimonials__item--active');
			slides[track.details.rel].setAttribute('inert', 'true');
		},
		animationEnded: ({ track }) => {
			const activeSlide = slides[track.details.rel];
			activeSlide.classList.add('v-testimonials__item--active');
			activeSlide.removeAttribute('inert');
			isAnimating = false;
		},
	});

	keen.on('slideChanged', (instance) => {
		[...dots].forEach((dot) => {
			dot.classList.remove('active');
		});

		dots[instance.track.details.rel].classList.add('active');
	});

	[...dots].forEach((dot) => {
		const targetSlide = parseInt(dot.dataset.slide, 10);

		dot.addEventListener('click', () => {
			if (isAnimating) {
				return;
			}

			keen.moveToIdx(targetSlide);
		});
	});

	nextBtn.addEventListener('click', () => {
		if (isAnimating) {
			return;
		}

		keen.next();
	});

	prevBtn.addEventListener('click', () => {
		if (isAnimating) {
			return;
		}

		keen.prev();
	});

	// Scroll to and activate the testimonial from hash
	if (window.location.hash) {
		const hash = window.location.hash.substring(1).replace('testimonial-', '');
		const targetDot = [...dots].filter((dot) => dot.dataset.hash === hash)[0];

		if (targetDot) {
			gsap.to(window, {
				duration: 0.75,
				scrollTo: {
					y:        testimonials.getBoundingClientRect().top + window.pageYOffset,
					offsetY:  50,
					autoKill: false,
				},
				onComplete: () => {
					keen.moveToIdx(parseInt(targetDot.dataset.slide, 10));
				},
			});
		}
	}
};

export default vTestimonials;
